export const LANG_LOAD = 'LANG_LOAD';
export const LANG_CONFIG = 'LANG_CONFIG';
